"use client";

import {useCustomer} from "../../../contexts/customerContext";
import {Icon} from "@iconify/react";
import Link from "next/link";
import {getShopConfig} from "@/server/shop/get-shop-config";

export default function UserLoginButton() {
    const nshop = getShopConfig();
    const {customer} = useCustomer();
    const { layout = 'classic' } = nshop.theme.header || {};
    switch (layout) {
        case 'minimal':{
            if (customer) {
                return (
                    <Link href="/account" title={'Account'} className={'flex items-start gap-1'}>
                        <svg width="28" height="28" viewBox="0 0 448 512">
                            <path fill="currentColor"
                                  d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128m89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4"></path>
                        </svg>
                        <div className={'hidden lg:block'}>
                            <div className={'text-xs opacity-70 font-medium'}>My Account</div>
                            <div className={'text-sm'}>{customer?.fname}</div>
                        </div>
                    </Link>
                )
            }
            return (
                <Link href={'/auth/login'} title={'Login'} className={'flex items-center gap-1'}>
                    <svg width="28" height="28" viewBox="0 0 448 512">
                        <path fill="currentColor"
                              d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128m89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4"></path>
                    </svg>
                    <div className={'hidden lg:block'}>
                        <div className={'text-xs opacity-70 font-medium'}>My Account</div>
                        <div className={'text-sm'}>Login / Register</div>
                    </div>
                </Link>
            )
        }
        default:{
            if (customer) {
                return (
                    <Link href="/account" title={'Account'}>
                        <svg width="28" height="28" viewBox="0 0 448 512">
                            <path fill="currentColor"
                                  d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128m89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4"></path>
                        </svg>
                    </Link>
                )
            }
            return (
                <Link href={'/auth/login'} title={'Login'}>
                    <svg width="28" height="28" viewBox="0 0 448 512">
                        <path fill="currentColor"
                              d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128m89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4"></path>
                    </svg>
                </Link>
            )
        }
    }
}